import { useEffect, useState } from "react";
import { GroupHistoryType, PagingType } from "../types";
import { groupApi } from "../api/group.service";

export const useGetGroupHistory = (
  group_id: string,
  initialParams?: Record<string, any>
) => {
  const [params, setParams] = useState<Record<string, any>>(
    initialParams || {}
  );
  const [data, setData] = useState<GroupHistoryType[]>([]);
  const [paging, setPaging] = useState<PagingType | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<any>(null);

  const fetchData = async (
    group_id: string,
    fetchParams: Record<string, any>
  ) => {
    try {
      setLoading(true);

      const response: any = await groupApi.getGroupHistory(
        group_id,
        fetchParams
      );

      setData(response?.data?.data?.history ?? []);
      setPaging(response?.data?.data?.paging ?? null);

      return true;
    } catch (err: any) {
      console.log("Get group history failed:", err);

      setError(err.message || "Something wrong");

      return false;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(group_id, params);
  }, [group_id, JSON.stringify(params)]);

  return {
    data,
    fetchData,
    paging,
    loading,
    error,
    params,
    setParams,
  };
};
